export default __webpack_public_path__ + "static/media/menu-search-icon-.fbc5a576.svg";